import {
  SETTING_LIST_REQUESTING,
  SETTING_LIST_SUCCESS,
  SETTING_LIST_ERROR,
  SETTING_UPDATE_STORE_REQUESTING,
  SETTING_UPDATE_STORE_SUCCESS,
  SETTING_UPDATE_STORE_ERROR
} from './constants'

export const settingListRequest = function settingListRequest (formData) {  
  return {
    type: SETTING_LIST_REQUESTING,
    formData
  }
}

export const settingListSuccess = function settingListSuccess (data) {  
  return {
    type: SETTING_LIST_SUCCESS,
    data
  }
}

export const settingListError = function settingListError (error) {  
  return {
    type: SETTING_LIST_ERROR,
    error
  }
}

export const settingUpdateStoreRequest = function settingUpdateStoreRequest (formData, callback) {  
  return {
    type: SETTING_UPDATE_STORE_REQUESTING,
    formData, 
    callback
  }
}

export const settingUpdateStoreSuccess = function settingUpdateStoreSuccess (data) {  
  return {
    type: SETTING_UPDATE_STORE_SUCCESS,
    data
  }
}

export const settingUpdateStoreError = function settingUpdateStoreError (error) {  
  return {
    type: SETTING_UPDATE_STORE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Setting/actions.js